module.exports = __webpack_public_path__ + "static/media/child2.e6210971.png";